<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 15 15"
    :width="width"
    :height="height"
  >
    <defs>
      <clipPath id="clip-path">
        <rect fill="none" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip-path)">
      <path
        :fill="color"
        d="M1.25,3.12A.62.62,0,0,1,.62,2.5V1.88A1.88,1.88,0,0,1,2.5,0h.62a.63.63,0,1,1,0,1.25H2.5a.63.63,0,0,0-.62.63V2.5A.62.62,0,0,1,1.25,3.12Z"
      />
      <path
        :fill="color"
        d="M12.5,3.12a.61.61,0,0,1-.62-.62V1.88a.63.63,0,0,0-.63-.63h-.63a.63.63,0,0,1,0-1.25h.63a1.88,1.88,0,0,1,1.87,1.88V2.5A.61.61,0,0,1,12.5,3.12Z"
      />
      <path
        :fill="color"
        d="M8.12,1.25H5.62A.63.63,0,0,1,5.62,0h2.5a.63.63,0,1,1,0,1.25Z"
      />
      <path
        :fill="color"
        d="M6.88,12.5H5.62a.63.63,0,0,1,0-1.25H6.88a.63.63,0,0,1,0,1.25Z"
      />
      <path
        :fill="color"
        d="M3.12,12.5H2.5A1.88,1.88,0,0,1,.62,10.62V10a.62.62,0,0,1,.63-.62.62.62,0,0,1,.63.62v.62a.63.63,0,0,0,.62.63h.62a.63.63,0,1,1,0,1.25Z"
      />
      <path
        :fill="color"
        d="M1.25,8.12A.63.63,0,0,1,.62,7.5V5A.63.63,0,0,1,1.88,5V7.5A.63.63,0,0,1,1.25,8.12Z"
      />
      <path
        :fill="color"
        d="M12.5,6.88a.63.63,0,0,1-.62-.63V5a.62.62,0,1,1,1.24,0V6.25A.63.63,0,0,1,12.5,6.88Z"
      />
      <path
        :fill="color"
        d="M14.87,11.64,9,5.74a.45.45,0,0,0-.29-.12A.41.41,0,0,0,8.28,6v8.56a.41.41,0,0,0,.41.41A.4.4,0,0,0,9,14.88l2.45-2.54h3.16a.41.41,0,0,0,.4-.41A.4.4,0,0,0,14.87,11.64Z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Picks",
  components: {},
  props: {
    color: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: true
    },
    height: {
      type: String,
      required: true
    }
  }
});
</script>
